import { Financial } from "@pages/auth/financial/Financial";

export function MyOrders() {
  return <Financial />;
}
